import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment-timezone'

import $ from 'jquery'
import 'timepicker/jquery.timepicker.min.js'
import 'timepicker/jquery.timepicker.min.css'

import styles from './index.css'

export default class TimeInput extends React.Component {
  
  static propTypes = {
    value     : PropTypes.string, 
    onChange  : PropTypes.func, 
    errorText : PropTypes.string,
    disabled  : PropTypes.bool
  }

  static defaultProps = {
    value     : '',
    onChange  : () => {},
    errorText : null,
    disabled  : false
  }

  constructor(props) {
    super(props)
    this.uid = `${(new Date()).getTime()}${Math.floor(Math.random()*10000)}`
    this.onChange = this.onChange.bind(this)
  }

  onChange(e) {
    this.props.onChange(e.target.value)
  }

  componentDidMount() {
    $(`#${this.uid}`).timepicker({})
    $(`#${this.uid}`).on('change', this.onChange)
  }

  componentWillUnmount() {
    $(`#${this.uid}`).off('change', this.onChange)
  }

  render() {
    return (
      <input 
        type="text" 
        value={this.props.value}
        onChange={this.onChange}
        className={styles.TimeInput}
        id={this.uid} 
        data-time-format="G:i"
        />
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/TimeInput/index.jsx